
// NO LONGER USED AS OF TOWN PORTAL UPDATE. Eventually willl delete this once profiling to make sure truly nothing is still used.


// --- DataGrid: shared base field keys (used only with `getKeysForView`) ---
const BASE_KEYS = [
  'parcel_id',
  'Address',
  'Muni',
  'ClientName',
  'SCARIndexNumber',
  'RunDate',
  'ManualReview',
  'PropertyAssessment',
  'EQ',
  'RAR',
  'IFMV',
  'SalePrice',
  'SaleDate',
  'RecentSale',
  'SubjectMarketValue',
  'OfferValue',
  'PctReduction',
  'RequestedAV',
  'Comp1',
  'Comp2',
  'Comp3',
  'Comp4',
  'Comp5',
  'CaseNotes',
  'AventineNote',
];

const TOWN_VIEW_KEYS = ['TownResponse', 'TownCounter', 'TownNotes'];

const REGULAR_VIEW_KEYS = [];

/** Keys passed into the row/column pipeline for the summary DataGrid (town vs internal). */
export const getKeysForView = (townView) => {
  const keys = [...BASE_KEYS];
  if (townView) {
    keys.push(...TOWN_VIEW_KEYS);
  } else {
    keys.push(...REGULAR_VIEW_KEYS);
  }
  return keys;
};

// --- Internal spreadsheet (New template / internal download) ---
export const INTERNAL_XLS_KEYS = [
  'parcel_id',
  'Year',
  'Address',
  'Muni',
  'PropertyZip',
  'ClientName',
  'SCARIndexNumber',
  'RunDate',
  'ManualReview',
  'PropertyAssessment',
  'RAR',
  'EQ',
  'IFMV',
  'SalePrice',
  'SaleDate',
  'RecentSale',
  'CompsCount',
  'SubjectMarketValue',
  'CaseStrength',
  'OfferValue',
  'PctReduction',
  'RequestedAV',
  'TownOffer',
  'PortfolioOffer',
  'PortfolioRequestedAV',
  'AlgorithmFirstOffer',
  'AlgorithmSecondOffer',
  'AlgorithmCeilingOffer',
  'AventineNote',
  'InternalNote',
  'Status',
  'RepID',
  'Workup',
  'Comp1',
  'Comp2',
  'Comp3',
  'Comp4',
  'Comp5',
];

/** @deprecated Use `INTERNAL_XLS_KEYS`; kept for existing imports. */
export const STANDARD_XLS_KEYS = INTERNAL_XLS_KEYS;

// --- Town / offers spreadsheet ---
export const TOWN_VIEW_XLS_KEYS = [
  'ClientName',
  'SCARIndexNumber',
  'Address',
  'RecentSale',
  'PropertyAssessment',
  'LOA',
  'IFMV',
  'SubjectMarketValue',
  'OfferValue',
  'RequestedAV',
  'PortfolioOffer',
  'PortfolioRequestedAV',
  'AventineNote',
  'Status',
  'TownResponse',
  'TownCounter',
  'TownNotes',
  'Workup',
  'Comp1',
  'Comp2',
  'Comp3',
  'Comp4',
  'Comp5',
  'parcel_id',
  'Year',
  'CaseType',
];

export { getTownViewXLSKeys } from './newColumns.js';

export const getColumnVisibilityModel = (rows, avToggleActive = false, isLoading = false) => {
  const visibilityModel = {
    RepID: false,
    ClientName: false,
    SalePrice: false,
    SaleDate: false,
    RunDate: false,
    ManualReview: false,
    OfferDiff: false,
    Taxes: false,
  };

  const hasCaseNotes =
    rows && rows.length > 0
      ? rows.some((row) => row.CaseNotes && row.CaseNotes.trim() !== '')
      : false;
  visibilityModel.CaseNotes = hasCaseNotes;

  if (avToggleActive) {
    visibilityModel.PropertyAssessment = false;
    visibilityModel.PortfolioRequestedAV = false;
  } else {
    visibilityModel.PropertyAssessment = false;
  }

  return visibilityModel;
};

export const COLUMN_CONFIG = {
  internal: {
    parcel_id: { width: 15, header: 'Parcel ID', hidden: false },
    Year: { width: 8, header: 'Year', format: '0' },
    Address: { width: 25 },
    Muni: { width: 8, header: 'Town' },
    PropertyZip: { width: 10, header: 'Zip', format: '00000' },
    ClientName: { width: 20, header: 'Client Name' },
    SCARIndexNumber: { header: 'Index Number' },
    RunDate: { width: 14, header: 'Workup run' },
    ManualReview: { width: 10, header: 'Manual review' },
    PropertyAssessment: { format: '#,##0', width: 10, header: 'Assessment' },
    RAR: { format: '0.00%', width: 8, header: 'RAR' },
    EQ: { format: '0.00%', width: 8, header: 'EQ' },
    IFMV: { format: '#,##0', width: 12, header: 'Town Eq Value' },
    SalePrice: { format: '#,##0', width: 12, header: 'Sale Price' },
    SaleDate: { header: 'Sale Date' },
    RecentSale: {},
    CompsCount: { format: '0', width: 10, header: '# Comps' },
    SubjectMarketValue: { format: '#,##0', width: 15, header: 'Aventine Workup' },
    CaseStrength: { format: '0%', width: 12, header: 'Case Strength' },
    OfferValue: { format: '#,##0', width: 12, header: 'Aventine Offer', bold: true, blueBackground: true },
    PortfolioOffer: { format: '#,##0', width: 12, header: 'Portfolio Offer' },
    RequestedAV: { format: '#,##0', width: 12, header: 'Requested AV' },
    TownOffer: { format: '#,##0', width: 12, header: 'Town Offer' },
    OfferDiff: { format: '#,##0', width: 12, header: 'Offer Diff' },
    PortfolioRequestedAV: { format: '#,##0', width: 12, header: 'Portfolio Requested AV' },
    AlgorithmFirstOffer: { format: '#,##0', width: 12, header: 'Algo 1st AV' },
    AlgorithmSecondOffer: { format: '#,##0', width: 12, header: 'Algo 2nd AV' },
    AlgorithmCeilingOffer: { format: '#,##0', width: 12, header: 'Algo Ceiling AV' },
    PctReduction: { format: '0.00%', width: 10, header: 'Pct Reduction', formula: true },
    AventineNote: { width: 20, header: 'Aventine Note' },
    InternalNote: { width: 20, header: 'Internal Note' },
    Status: { width: 10, header: 'Status' },
    RepID: {},
    Comp1: { width: 25, header: 'Comp 1' },
    Comp2: { width: 25, header: 'Comp 2' },
    Comp3: { width: 25, header: 'Comp 3' },
    Comp4: { width: 25, header: 'Comp 4' },
    Comp5: { width: 25, header: 'Comp 5' },
    Workup: { width: 40, header: 'Workup' },
  },

  townView: {
    ClientName: { width: 20, header: 'Client Name' },
    SCARIndexNumber: { header: 'Index Number' },
    // SCARHearingDate: { width: 12, header: 'Court Date' },
    Address: { width: 25 },
    RecentSale: {},
    PropertyAssessment: { format: '#,##0', width: 10, header: 'Assessment' },
    LOA: { format: '0.00%', width: 10, header: 'LOA' },
    IFMV: { format: '#,##0', width: 12, header: 'Full MV' },
    SubjectMarketValue: { format: '#,##0', width: 15, header: 'Aventine Workup' },
    OfferValue: { format: '#,##0', width: 12, header: 'Aventine Offer' },
    PortfolioOffer: { format: '#,##0', width: 12, header: 'Portfolio Offer' },
    RequestedAV: { format: '#,##0', width: 12, header: 'Requested AV' },
    PortfolioRequestedAV: { format: '#,##0', width: 12, header: 'Portfolio Requested AV' },
    Status: { width: 10, header: 'Status' },
    AventineNote: { width: 30, header: 'Aventine Note' },
    TownResponse: { width: 14, header: 'Town Response' },
    TownCounter: { format: '#,##0', width: 12, header: 'Town Counter ($)' },
    PriorTownOffer: { format: '#,##0', width: 16, header: 'Prior Town Offer (AV)' },
    TownNotes: { width: 30, header: 'Town Notes' },
    Comp1: { width: 25, header: 'Comp 1' },
    Comp2: { width: 25, header: 'Comp 2' },
    Comp3: { width: 25, header: 'Comp 3' },
    Comp4: { width: 25, header: 'Comp 4' },
    Comp5: { width: 25, header: 'Comp 5' },
    Workup: { width: 40, header: 'Workup' },
    parcel_id: { width: 15, header: 'Parcel ID', hidden: false },
    Year: { width: 8, header: 'Year', hidden: true, format: '0' },
    CaseType: { width: 12, header: 'CaseType', hidden: true },
  },
};

export const DEFAULT_TABLE_PROPS = {
  density: 'compact',
  disableRowSelectionOnClick: true,
  disableColumnFilter: true,
  disableVirtualization: false,
  autoHeight: false,
};
